import React, { useEffect, useState } from "react";
import styles from "./TabGroup.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useIntl } from "react-intl";
import { Tab, TabList } from "@fluentui/react-components";

export function TabGroup({ list, onSelectFacetIndex, theme, activeFilter = null }) {
  const [active, setActive] = useState(list[0]);
  const themeSelected = theme === "primary" ? styles.primary : styles.secondary;

  const intl = useIntl();

  useEffect(() => {
    if (list.includes(activeFilter)) {
      setActive(activeFilter);
    }
  }, [activeFilter, list]);

  const setTabActive = (type, index) => {
    setActive(type);

    if (onSelectFacetIndex) {
      onSelectFacetIndex(index);
    }
  };

  const getActiveTab = type => {
    const isActive = active === type ? true : false;

    if (isActive) {
      const activeClass = theme === "primary" ? styles.activeTabPrimary : styles.activeTabSecondary;

      return activeClass;
    }

    return null;
  };

  const formattedType = type => {
    // Remove '-' with ' '. First letter of each word uppercase
    let formatted = type.replace(/-/g, " ").replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1));

    if (formatted === "") {
      formatted = "Newest";
    }

    return intl.formatMessage({
      id: `media-browser.tab.${type}`,
      defaultMessage: formatted
    });
  };

  return (
    <>
      <TabList
        selectedValue={active}
        onTabSelect={(_, data) => {
          // Calculate the index of the selected tab
          const index = list.indexOf(data.value);
          setTabActive(data.value, index);
        }}
      >
        {list.map((type, index) => (
          <Tab key={index} value={type} index={index}>
            {formattedType(type)}
          </Tab>
        ))}
      </TabList>
      {/* <div className={styles.tabContainer}>
        {list.map((type, index) => (
          <button
            key={type}
            className={classNames(styles.tab, getActiveTab(type), themeSelected)}
            onClick={() => setTabActive(type, index)}
          >
            {formattedType(type)}
          </button>
        ))}
      </div> */}
    </>
  );
}

TabGroup.propTypes = {
  list: PropTypes.array,
  onSelectFacetIndex: PropTypes.func,
  theme: PropTypes.string
};
